import { gql } from 'apollo-boost';

export const PREFERRED_LANGUAGE_QUERY = gql`
    query preferredLanguage {
        preferredLanguage{
            value
        }
    }
`;
